//This util exists to circumvent tree shaking
const checkUseLoggingVariable = (expectedValue = 'yes') => {
  return process.env.USE_LOGGING === expectedValue;
};

export default checkUseLoggingVariable;
